module.exports = __webpack_public_path__ + "assets/img/events-point-01.992accbe.png";